import React from 'react';
import { Card, Descriptions, Image, Tag, Space, Typography } from 'antd';
import { BANNERS_IMAGEURL } from '../../config';

const { Title, Text } = Typography;

const ViewBanner = ({ viewdata, children }) => {
  if (!viewdata) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Text type="secondary">No banner data to display</Text>
      </div>
    );
  }

  const getShowName = (record) => {
    return record.show_type === 'movie' 
      ? record.video_show_title 
      : record.tv_show_name;
  };

  const resolveImageUrl = (path) => {
    if (!path) return '';
    return path.startsWith('http') ? path : `${BANNERS_IMAGEURL}${path}`;
  };

  return (
    <div>
      <Title level={4}>Banner Details</Title>
      
      <Card style={{ marginBottom: '16px' }}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Banner Name">
            <Text strong>{viewdata.banner_name}</Text>
          </Descriptions.Item>
          
          <Descriptions.Item label="Show Type">
            <Tag color="blue">{viewdata.show_type}</Tag>
          </Descriptions.Item>
          
          <Descriptions.Item label="Show Name">
            <Text>{getShowName(viewdata)}</Text>
          </Descriptions.Item>
          
          <Descriptions.Item label="Content Variant">
            {viewdata.content_variant ? (
              <Tag color="purple">{viewdata.content_variant}</Tag>
            ) : (
              <Text type="secondary">Not set</Text>
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Content ID">
            {viewdata.content_id === null || viewdata.content_id === undefined ? (
              <Text type="secondary">Not set</Text>
            ) : (
              <Text>{viewdata.content_id}</Text>
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Status">
            <Tag color={viewdata.banner_is_active === 'Y' ? 'green' : 'red'}>
              {viewdata.banner_is_active === 'Y' ? 'Active' : 'Inactive'}
            </Tag>
          </Descriptions.Item>
          

          <Descriptions.Item label="Artwork">
            {/* Artwork is the per-language image sets only: the banner's own
                desktop_image / mobile_image / horizontal_card_image columns are
                deliberately not shown, whatever they still hold. */}
            {(() => {
              const imageSets = Array.isArray(viewdata.images) ? viewdata.images : [];
              if (imageSets.length === 0) {
                return <Text type="warning">No artwork uploaded</Text>;
              }
              return (
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                  {imageSets.map((set, index) => {
                    const crops = [
                      { label: 'Desktop', src: set.banner_image, width: 200 },
                      { label: 'Mobile', src: set.card_image, width: 120 },
                      {
                        label: 'Horizontal card',
                        src: set.horizontal_movie_card_image,
                        width: 160,
                      },
                      {
                        label: 'Horizontal sleek banner',
                        // Wider than the horizontal card on purpose: it is
                        // uploaded 480x180 against 320x180, so the two are told
                        // apart at a glance.
                        src: set.horizontal_sleek_banner_image,
                        width: 240,
                      },
                    ].filter((crop) => crop.src);
                    return (
                      <div key={set.image_id ?? `${set.lang_id}-${index}`}>
                        <Text strong style={{ display: 'block', marginBottom: '8px' }}>
                          {set.lang_name || `Language ${set.lang_id}`}
                          {set.lang_is_active === 'N' ? ' (Inactive)' : ''}
                        </Text>
                        {crops.length === 0 ? (
                          <Text type="warning">No artwork in this language</Text>
                        ) : (
                          <Space size="large" wrap>
                            {crops.map((crop) => (
                              <div key={crop.label}>
                                <Text
                                  type="secondary"
                                  style={{ display: 'block', fontSize: '12px' }}
                                >
                                  {crop.label}
                                </Text>
                                <Image
                                  width={crop.width}
                                  src={resolveImageUrl(crop.src)}
                                  alt={`${crop.label} banner`}
                                  style={{ borderRadius: '4px' }}
                                />
                              </div>
                            ))}
                          </Space>
                        )}
                      </div>
                    );
                  })}
                </Space>
              );
            })()}
          </Descriptions.Item>

        </Descriptions>
      </Card>
      
      {children}
    </div>
  );
};

export default ViewBanner;
